const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/DashboardPage/Cards/NextSurgeryAppointment/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        cardTitle: 'Eintrittstermin',
        surgeryHintTitle: 'Wichtige Informationen zur Nahrungsaufnahme vor Ihrem Eingriff',
        surgeryHintText:
            'Klare Flüssigkeiten (Tee, Wasser mit wenig Kohlensäure, schwarzer Kaffee mit oder ohne Zucker, ohne Milch oder Kaffeerahm) bis 2 Std. vor dem geplanten Eingriff (in der Regel, bis Sie Ihr Hause für den Spitaleintritt verlassen). \nLetzte Nahrungsaufnahme (inkl. Milch) soll 6 Stunden vor dem Eintritt erfolgen.',
    },
    __RELATIVE_SOURCE_FILE__
);
